<template>
  <div 
    @click="navigate"
    class="group relative bg-white dark:bg-gray-800 rounded-2xl p-6 lg:p-8 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer border border-gray-100 dark:border-gray-700 hover:border-blue-200 dark:hover:border-blue-800"
  >
    <!-- Icon Container -->
    <div :class="[iconClasses, 'w-16 h-16 lg:w-20 lg:h-20 rounded-2xl flex items-center justify-center text-4xl lg:text-5xl mb-6 group-hover:scale-110 transition-transform duration-300']">
      {{ icon }}
    </div>
    
    <!-- Content -->
    <h4 class="text-xl lg:text-2xl font-bold text-gray-900 dark:text-white mb-3 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
      {{ title }}
    </h4>
    <p class="text-gray-600 dark:text-gray-400 leading-relaxed text-sm lg:text-base mb-6">
      {{ description }}
    </p>
    
    <!-- Footer / Action -->
    <div class="flex items-center text-blue-600 dark:text-blue-400 font-semibold text-sm group-hover:gap-2 transition-all duration-300">
      <span>Open Dashboard</span>
      <svg class="w-5 h-5 translate-x-0 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
      </svg>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const props = defineProps({
  title: { type: String, required: true },
  description: { type: String, required: true },
  icon: { type: String, required: true },
  color: { type: String, default: 'blue' },
  route: { type: String, required: true }
})

// ✅ Map color prop to full Tailwind classes to ensure JIT compilation works perfectly
const iconClasses = computed(() => {
  const colorMap = {
    violet: 'bg-violet-100 text-violet-600 dark:bg-violet-900/30 dark:text-violet-400',
    secondary: 'bg-emerald-100 text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-400',
    blue: 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400',
    slate: 'bg-slate-100 text-slate-600 dark:bg-slate-900/30 dark:text-slate-400',
    emerald: 'bg-emerald-100 text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-400',
  }
  return colorMap[props.color] || colorMap.blue
})

const navigate = () => {
  if (props.route) {
    router.push(props.route)
  }
}
</script>